export default "__VITE_ASSET__BCNhFjyG__"